export default "__VITE_ASSET__DzS9oRz7__"